import { NgModule } from "@angular/core";
import { RouterModule } from '@angular/router';

import { AuthGuard } from './core/auth/auth.guard';
import { FullMenuComponent } from './full-menu/full-menu.component';
import { HomeComponent } from './home/home.component';
import { SearchComponent } from './search/search.component';
import { ErrorComponent } from './shared/error/error.component';
import { OccurencesComponent } from './occurences/occurences.component';
import { BrokerageFeeComponent } from './brokerage-fee/brokerage-fee.component';
import { NotFoundRouteComponent } from './not-found-route/not-found-route.component';
import { BrowserWarningComponent } from './browser-warning/browser-warning.component';

const routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'busca', component: SearchComponent, canActivate: [AuthGuard] },
  { path: 'error', component: ErrorComponent, canActivate: [AuthGuard] },
  { path: 'menu', component: FullMenuComponent, canActivate: [AuthGuard] },
  { path: 'cadastroDemanda', component: OccurencesComponent, canActivate: [AuthGuard] },
  { path: 'taxaCorretagem', component: BrokerageFeeComponent, canActivate: [AuthGuard] },
  { path: 'cotas', loadChildren: './shares/shares.module#SharesModule', canActivate: [AuthGuard] },
  { path: 'usuarios', loadChildren: './pages/users/users.module#UsersModule', canActivate: [AuthGuard] },
  { path: 'status-cota', loadChildren: './quota-status/quota-status.module#QuotaStatusModule', canActivate: [AuthGuard] },
  { path: 'status-operacoes', loadChildren: './trade-status/trade-status.module#TradeStatusModule', canActivate: [AuthGuard] },
  { path: 'browser-warning', component: BrowserWarningComponent, canActivate: [AuthGuard] },

  // micro front-end OUTPUT
  { path: 'motor-relatorio', loadChildren: './micro-frontend/pages/motor-relatorio/motor-relatorio.module#MotorRelatorioModule', canActivate: [AuthGuard] },
  { path: 'gestao-de-caixa', loadChildren: './micro-frontend/pages/gestao-de-caixa/gestao-de-caixa.module#GestaoDeCaixaModule', canActivate: [AuthGuard] },

  // micro front-end INPUT
  {
    path: 'boleta-upload',
    loadChildren: './micro-frontend/pages/boleta-upload/boleta-upload.module#BoletaUploadModule',
    canActivate: [AuthGuard]
  },
  {
    path: 'ocultacaocda',
    loadChildren: './micro-frontend/pages/cda-hidden/cda-hidden.module#CdaHiddenModule',
    canActivate: [AuthGuard]
  },

  {
    path: 'justificar-ativos',
    loadChildren: './micro-frontend/pages/justificar-ativos/justificar-ativos.module#JustificarAtivosModule',
    canActivate: [AuthGuard]
  },
  {
    path: 'upload-arquivos',
    loadChildren: './micro-frontend/pages/upload-arquivos/upload-arquivos.module#UploadArquivosModule',
    canActivate: [AuthGuard]
  },
  {
    path: 'status-liquidacao',
    loadChildren: './micro-frontend/pages/status-liquidacao/status-liquidacao.module#StatusLiquidacaoModule',
    canActivate: [AuthGuard]
  },

  { path: '**', patchMatch: 'full', component: NotFoundRouteComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)]
})
export class AppRoutingModule { }
